import api from "@/lib/api";
import type {
  SupportReportCreate,
  SupportReportSent,
} from "@/types/support/api-types/support-report-types";

// The backend makes one Clerk lookup and up to three GitHub calls, 5 s each: its own 503 arrives before this.
const SEND_TIMEOUT_MS = 30_000;

export const supportReportsApi = {
  send: async (report: SupportReportCreate): Promise<SupportReportSent> => {
    const response = await api.post<SupportReportSent>("/support/reports", report, {
      timeout: SEND_TIMEOUT_MS,
    });
    return response.data;
  },
};
